import type {PublicMethodUtils} from '@wix/document-services-types'
import type {CssStylePublicAPI} from '@wix/document-services-public-types'
import type {PublicModuleDeclaration} from '../../documentServicesInitialisation'

export default function (publicMethodUtils: PublicMethodUtils): PublicModuleDeclaration<CssStylePublicAPI> {
    const {
        extensionPublicAPI: {constants, dataManipulation, getter}
    } = publicMethodUtils

    return {
        methods: {
            components: {
                cssStyle: {
                    update: dataManipulation('components.cssStyle.update'),
                    get: getter('components.cssStyle.get'),
                    remove: dataManipulation('components.cssStyle.remove'),
                    connectToGlobalStyle: dataManipulation('components.cssStyle.connectToGlobalStyle'),
                    scoped: {
                        remove: dataManipulation('components.cssStyle.scoped.remove')
                    }
                }
            },
            cssStyle: {
                CSS_SHORTHAND_MAPPINGS: constants('style.CSS_SHORTHAND_MAPPINGS')
            }
        }
    }
}
